import './instagram_message_base_parser.js.coffee'
Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageStoryReplyParser extends Models.Parsers.InstagramMessageBaseParser
  canHandle: (messageJSON) ->
    messageJSON.message_type == 'story_reply'

  parse: (messageJSON) ->
    builder = new Models.Builders.InstagramMessageStoryReplyBuilder
    @_doParse(builder, messageJSON)
    message = @_getMessage(messageJSON)
    builder.messageText = message.text
    replyTo = message.reply_to
    story = replyTo.story
    builder.storyUrl = story.url
    builder.storyId = story.id
    return builder.build()
